module.exports = __webpack_public_path__ + "static/media/soundConstNew.25bd4e0f.mp3";